import React, { Suspense, lazy } from 'react'

const RatemapInner = lazy(() =>
    import('./RateMap').then(module => ({ default: module.Ratemap })),
)

export function Ratemap(props) {
    return (
        <Suspense fallback={null}>
            <RatemapInner {...props} />
        </Suspense>
    )
}
